import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Route-driven PWA identity: makes "Add to Home Screen" / "Install app" pick the
// right app (Management / Worker / Desktop / Driver) no matter which page the
// user installs from — including login pages, where no InstallAppButton exists.
const BRANDS = [
  { match: "/desktop", manifest: "/manifest-desktop.json", apple: "/desk-apple-touch.png", title: "MUSA Desktop", theme: "#0F172A" },
  { match: "/worker", manifest: "/manifest-worker.json", apple: "/mgmt-apple-touch.png", title: "MUSA Worker", theme: "#0F172A" },
  { match: "/managementusa", manifest: "/manifest-mgmt.json", apple: "/mgmt-apple-touch.png", title: "Management", theme: "#0F172A" },
  { match: "/colonies", manifest: "/manifest-mgmt.json", apple: "/mgmt-apple-touch.png", title: "Management", theme: "#0F172A" },
];
const DEFAULT_BRAND = { manifest: "/manifest.json", apple: "/apple-touch-icon.png", title: "CPS Driver", theme: "#003366" };

export default function ManifestSwapper() {
  const { pathname } = useLocation();
  useEffect(() => {
    const brand = BRANDS.find((b) => pathname.startsWith(b.match)) || DEFAULT_BRAND;
    const set = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el && el.getAttribute(attr) !== value) el.setAttribute(attr, value);
    };
    set("link[rel='manifest']", "href", brand.manifest);
    set("link[rel='apple-touch-icon']", "href", brand.apple);
    set("meta[name='apple-mobile-web-app-title']", "content", brand.title);
    set("meta[name='theme-color']", "content", brand.theme);
  }, [pathname]);
  return null;
}
